/**
 * Created by Ivan on 24.05.2025
 */

const SafeTutorial = function () {
    return new TutorialScenario(SafeTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(SafeTutorial.CONFIG.tutorial[0]),
            TileGameTutorialHelper.createPlayCardStep(SafeTutorial.CONFIG.tutorial[1]),
            TileGameTutorialHelper.createPlayCardStep(SafeTutorial.CONFIG.tutorial[2])
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(SafeTutorial.NAME);
            Game.currentGame.hand.setCards(SafeTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(SafeTutorial.NAME)
    });
};

SafeTutorial.NAME = "safe";
SafeTutorial.CONFIG = {
    handValues: ["8h"],
    tutorial: [{
        force: "SafeTutorialMessage1",
        importantCards: [SafeCard],
        filter: [SafeCard]
    }, {
        force: "SafeTutorialMessage2",
        importantCards: [SafeCard],
        filter: [SafeCard]
    }, {
        force: "SafeTutorialMessage3",
        importantCards: [SafeCard],
        filter: [SafeCard]
    }]
};
